import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import ODataUtils from "../../../utils/odata.utils";
import { ApiTemplateConstants } from "../../../constants/api-constants/api-template.constants";
import { SendSmsServiceConstants } from "./send-sms-service.constants";
import { ApiCommunicationConstants } from "../../../constants/api-constants/api-communication.constants";
import { ApiAdminConstants } from "src/app/shared/constants/api-constants/api-admin.constants";
let SendSmsService = class SendSmsService {
    http;
    componentName = SendSmsServiceConstants.COMPONENT_NAME;
    adHocComms = SendSmsServiceConstants.AD_HOC_COMMS;
    constructor(http) {
        this.http = http;
    }
    postSms(params) {
        return this.http.post(`${ApiCommunicationConstants.URL}/${ApiCommunicationConstants.FUNCTION_GENERATE_SMS}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    getSmsTemplates(currentStep, moduleId) {
        const params = {
            $expand: "attachment",
            $filter: `stepName eq '${ODataUtils.encryptQueryContent(currentStep)}' and moduleId eq ${moduleId}`
        };
        if (currentStep == this.adHocComms) {
            params.$filter = `moduleId eq ${moduleId}`;
        }
        return this.http.get(ApiTemplateConstants.URL, { params })
            .pipe(map(response => {
            return response;
        }));
    }
    logCommunication(communication, jobId, stepName, stepId) {
        const request = {
            communication,
            jobId,
            stepName,
            stepId
        };
        // const endPointUrl = "api/v2/Communication";
        return this.http.post(`${ApiCommunicationConstants.URL}/${ApiCommunicationConstants.FUNCTION_LOG_COMMUNICATION}`, request)
            .pipe(map(response => {
            return response;
        }));
    }
    getPortalUrl() {
        return this.http.get(`${ApiAdminConstants.URL}/${ApiAdminConstants.FUNCTION_GET_PORTAL_URL}`);
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
SendSmsService = __decorate([
    Injectable({
        providedIn: "root"
    })
], SendSmsService);
export { SendSmsService };
